import React from 'react';
import {useBanners} from '../../api/hooks';
import Loader from '../pages/Loader';
import Error from '../pages/Error';

const validBanner = banner => {

    const currentDate = new Date().getTime();
    const startDate = new Date(banner.start_date).getTime();
    if (banner.end_date) {
        const endDate = new Date(banner.end_date).getTime();
        return endDate > currentDate && startDate <= currentDate;
    }
    return startDate <= currentDate;
};

const Banner = ({setShowBanner}) => {
    const {data: banners, isLoading, error} = useBanners();

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    if (banners.length < 1) {
        return null;
    }

    const closeBanner = () => {
        setShowBanner(false);
        const currentDate = new Date();
        const hideBannerUntil = currentDate.setDate(currentDate.getDate() + 1);
        window.localStorage.setItem('hideBannerUntil', hideBannerUntil);
    };

    // We only use the first banner at the moment
    const banner = banners.find(validBanner);
    const {color, content} = banner;

    const classNames = require('classnames');
    let bannerClasses = classNames({
        'alert-danger': color === 'red',
        'alert-warning': color === 'yellow',
        'alert-success': color === 'green',
        'alert-dark': color === 'gray',
    });

    return (

        <div className={'banner-wrapper alert ' + bannerClasses} role="alert">
            <div className="banner-content">
                <div className="la la-close close-button" onClick={closeBanner} />
                <div dangerouslySetInnerHTML={{__html: content}} />
            </div>
        </div>
    );
};

export default Banner;
